console.log("column-content-module Module Loaded");


// WEBPACK FOOTER //
// ./wp-content/themes/usdigitalpartners/modules/column-content-module/includes/column-content-module.js